/**
* CLASS DataGridContainer
*
* Contiene el contenedor de la tabla de datos
*
* @author Hector Morales <hector.morales@ikarosofttechnology.com>
*/


import React, { Component } from 'react';
import DataGridList from './DataGridList';
import Table from 'react-bootstrap/Table';
import {cargarFilas} from '../api_calls/ApiCalls';
import globalState from '../configuration/GlobalState';
import alertify from 'alertifyjs';
import '../../css/alertify.css';

class DataGridContainer extends Component {
    constructor(props) {
        let  arrayContent = [];
        super(props);
        this.state = {  
                        content  : arrayContent,
                        database : globalState.getState().companyData[0].bd
                     }        
    }
  	handleClick(val) {
  	  	this.setState({ justClicked: val });
  	}
    cargaFilas(){
        let searchWord   = '';
        let showRecords  = 15;
        let offsetRecord = 0;
        let dataFilter = []; 
        let date1 = this.props.date1;
        let date2 = this.props.date2;
        if(this.props.parametro !== undefined){
            if(this.props.parametro.hasOwnProperty('searchWord')){
                searchWord = this.props.parametro.searchWord; 
                showRecords = this.props.parametro.showRecords;  
                offsetRecord = this.props.parametro.offsetRecord;                  
            }  
            if(this.props.parametro.hasOwnProperty('dataFilter')){  
                dataFilter = this.props.parametro.dataFilter;
            }    
        } 
        
        let sqlParams = JSON.parse(JSON.stringify(this.props.sqlParams));
        if(Object.keys(dataFilter).length > 0){            
            for(var i in dataFilter){                
                if(dataFilter[i] !== ""){
                    sqlParams.sqlWhere.push(" AND "+i+" = '"+dataFilter[i]+"'");
                }
            }            
        }
             
        cargarFilas(this.props.apiField,searchWord,showRecords,offsetRecord,date1,date2,sqlParams,'rows',this.state.database,this.props.apiRoute)        
        .then(res => {
            var response = res.data; 
            if (response.msg === "error") {
                alertify.alert('Error!', 'Ha ocurrido un error accesando a la base de datos!<br />Codigo de Error: '+response.detail);
            } else {
                this.setState({ content: response });
                globalState.dispatch({
                    type   : "data_"+this.props.mainContainer,
                    params :  response
                }); 
            }
        })
        .catch( err => {            
            alertify.alert('Error!', 'No se ha logrado la conexion con el servidor!<br />'+err);
        });
    }
    componentWillMount() {
        this.cargaFilas();        
    }
    componentDidUpdate(prevProps){        
        if (this.props.parametro !== prevProps.parametro) {           
           this.cargaFilas(); 
        } 
    }
  	render() {  
        if (this.state.content.length > 0) {
            return (//carga dinamica de la cabecera y del listado
                <div id="no-more-tables" ref = {this.props.divPDF}>
                    <Table className="tableDataGrid" responsive id="table-to-xls" style={{marginBottom: '2rem'}}>
                        <thead className="cf">
                            <tr>
                                <th style={{fontSize:'12px'}}>No.</th>
                                {
                                    this.props.colsData.map((colsData,i) => {
                                        let fila = null;                                        
                                        if(!colsData.onlyXLS && colsData !== ''){
                                            fila = <th key={i} style={{fontSize:'12px'}}>{colsData.label}</th>
                                        }
                                        return fila;                                        
                                    })
                                }
                            </tr>
                        </thead>      
                        <DataGridList listado={this.state.content} 
                                      titulo={this.props.titulo}
                                      funcionClick={this.props.funcionClick} 
                                      colsData={this.props.colsData} 
                                      apiField={this.props.apiField}
                                      apiRoute={this.props.apiRoute}
                                      formFields={this.props.formFields}
                                      mainContainer={this.props.mainContainer}
                                      colsHeaders={this.props.colsHeaders}
                                      automatica={this.props.automatica}
                                      enableRowClick={this.props.enableRowClick} 
                                      funcionEdit = {this.props.funcionEdit}
                                      tbarEdit = {this.props.tbarEdit}
                                      tbarItems = {this.props.tbarItems}
                                      funcionEditParams = {this.props.funcionEditParams} 
                                      funcionAfterUpdate = {this.props.funcionAfterUpdate} 
                                      funcionBeforeDelete = {this.props.funcionBeforeDelete} 
                                      enableBtnEdit={this.props.enableBtnEdit}
                                      permisoBtnUpdate = {this.props.permisoBtnUpdate}
                                      enableBtnDel={this.props.enableBtnDel}
                                      dataLog={this.props.dataLog}/>                                       
                    </Table>
                </div>
            )
        } else {
            return <div style={{marginBottom: '2rem'}} className="titulo">No hay registros...</div>
        }
    } 
}

export default DataGridContainer